import * as S from "./styled"
import styled, { css } from "styled-components"
import device from "../../theme/devices"

export const Item = styled(S.Item)`
  ${props =>
    props.setMinWidth &&
    css`
      min-width: 350px;
    `};
  ${props =>
    props.animateImageOnHover &&
    css`
      .fluid-container {
        overflow: hidden;

        .gatsby-image-wrapper {
          transition: all 650ms ease-out;
        }
      }

      :hover {
        cursor: pointer;
        a {
          button {
            transform: translateX(7px);
          }
          span {
            text-decoration: underline;
          }
        }
        .fluid-container .gatsby-image-wrapper {
          transform: scale(1.06);
        }
      }
    `}
`

export const FluidContainer = styled.div`
  height: 390px;
  width: 290px;
  position: relative;
  @media (${device.desktop}) {
    height: 610px;
    width: 460px;
  }
`

export const Background = styled.img`
  object-fit: cover;
  max-height: 390px;
  @media (${device.desktop}) {
    max-height: 610px;
  }
`

export const ContentContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
  background: linear-gradient(to bottom, transparent 20%, #0009);

  @media (${device.tablet}) {
    padding: 25px 110px 25px 20px;
  }

  @media (${device.desktop}) {
    background: linear-gradient(to bottom, transparent 10%, #0009);
  }
`
